import { Dialog, TextV2 } from '@insights-ltd/design-library/components';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import MailSentIcon from 'components/Svgs/ASSET-PaperPlane.svg';

export type EmailProgressDialogV2Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  header: string;
  body: string;
};

export const EmailProgressDialogV2 = ({
  open,
  onClose,
  title,
  header,
  body,
}: EmailProgressDialogV2Props) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      content={
        <Box
          sx={{
            margin: 1,
            textAlign: 'center',
          }}
        >
          <Box
            sx={{
              marginBottom: 2,
            }}
          >
            <img alt={title} src={MailSentIcon} width={120} />
          </Box>
          <Box
            sx={{
              marginBottom: 2,
            }}
          >
            <TextV2 variant="h4">{header}</TextV2>
          </Box>
          <Box
            sx={{
              marginBottom: 2,
            }}
          >
            <TextV2 component="span">{body}</TextV2>
          </Box>
        </Box>
      }
      secondaryButtonText={t(
        'ui.event-management.events.download-or-share-profiles.confirmation-modal.close',
      )}
    />
  );
};
